import React, { useState, useRef, useEffect } from "react";
import copy from './copy.svg';
import './payment.css';

const Payment = () => {
    const [accountType, setAccountType] = useState('bezny');
    const button1Ref = useRef(null);
    const [button2Width, setButton2Width] = useState(0);

    useEffect(() => {
        if (button1Ref.current) {
            const button1W = button1Ref.current.offsetWidth;
            setButton2Width(button1W);
        }
    }, [])

    const accountData = {
        transparentny: {
            title: 'TRANSPARENTNÝ ÚČET',
            qrCode: './images/trans.png',
            iban: 'SK81 7500 0000 0040 3486 6169',
            buttonClass: 'trans'
        },
        bezny: {
            title: 'BEŽNÝ ÚČET',
            qrCode: './images/bez.png',
            iban: 'SK69 7500 0000 0040 3455 6179',
            buttonClass: 'bez'
        }
    };

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(accountData[accountType].iban).then(() => {
            alert('IBAN bol skopirovaný!');
        }).catch(err => {
            console.error('Nepodarilo sa skopírovať IBAN: ', err);
        });
    };

    const toggleAccountType = (type) => {
        setAccountType(type);
    };

    return (
        <div className="payment-main">
            <div className="payment-container">
                <h3 className="payment-container-title">{accountData[accountType].title}</h3>
                <img className="payment-qr" src={accountData[accountType].qrCode} alt="QR code" />
                <div className="payment-buttons">
                    <button
                        className={accountType === 'bezny' ? 'active' : ''}
                        onClick={() => toggleAccountType('bezny')}
                        style={{ width: `${button2Width}px` }}
                    >
                        Bežný účet
                    </button>
                    <button
                        className={accountType === 'transparentny' ? 'active' : ''}
                        onClick={() => toggleAccountType('transparentny')}
                        ref={button1Ref}
                    >
                        Transparentný účet
                    </button>
                </div>
                <div className="payment-iban">
                    <h3 id="address" className="iban-text">{accountData[accountType].iban}</h3>
                    <button onClick={handleCopyToClipboard} className="payment-copy-button">
                        <img src={copy} alt="copy icon" className="payment-copy-icon" />SKOPÍROVAŤ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Payment;